import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  gap: (p) => p.spacing(1),
  alignItems: 'center',
  width: '100%',
  mt: (p) => p.spacing(1),
};
